import { ISymbol } from '../SymbolSelect'

const lotSizeCalculatorFilter = (symbols: ISymbol[]) => {
  const additionalSymbols = ['XAGUSD', 'XAUUSD']
  return symbols.filter(
    (symbol: ISymbol) => symbol.type === 'forex' || additionalSymbols.includes(symbol.name)
  )
}

export default lotSizeCalculatorFilter
